// 创建 优惠券 组件
class LeproOffCode extends HTMLElement {
  constructor() {
    super();

    this.currencySymbol = ''

    this.startAt = ''
    this.endAt = ''

    this.gid = ''
    this.vid = ''
    this.code = ''
    this.price = ''

    this.variantId = ''
    this.variantPrice = 0  // variant.price in cents
    this.savingCents = 0   // discount amount in cents
    this.salePrice = 0     // variant.price - savingCents

    this.discount = {}

    this.dayNum = 7 // 7 day inner show code

    this.timer = null
    this.timerCode = null

  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.init();
  }

  queryScope(selector) {
    const info = this.closest('product-info');
    return info?.dataset.collectionDetailPrepared ? $(info).find(selector) : $(selector);
  }

  init() {
    const toggle = this.querySelector('.discount-toggle')
    if (toggle) toggle.checked = false
    this.initVariantInfo()
    this.bindEvent()
  }

  // 初始化变体信息，以及对折扣信息处理
  initVariantInfo() {
    this.queryScope('.le-fixed-off-block').hide();
    const variantFields = this.queryScope('[data-detail-variant-fields], #product-variant-fields');
    if (variantFields[0]?.innerHTML) {
      const metafieldsCustoms = JSON.parse(variantFields[0].innerHTML)

      this.variantId = metafieldsCustoms?.variantPorduct?.id || ''
      this.variantPrice = metafieldsCustoms?.variantPorduct?.price || 0

      if (metafieldsCustoms?.currencySymbol) {
        this.currencySymbol = metafieldsCustoms.currencySymbol
      }

      const product_detail_max_discount = metafieldsCustoms?.metafieldsCustoms?.variants_discounts_and_marketing?.product_detail_max_discount || null

      // B2B Catalog: compare_at_price > price → show discount badge, skip coupon code
      const _vp = metafieldsCustoms?.variantPorduct
      const _isB2B = window.isB2BCustomer === true

      if (_isB2B) {
        const pct = (_vp?.compare_at_price > _vp?.price)
          ? Math.round((_vp.compare_at_price - _vp.price) / _vp.compare_at_price * 100)
          : 0
        if (pct > 0) {
          this.queryScope('.le-fixed-off-block .code-price').html(pct + '%')
          this.queryScope('.le-fixed-off-block').show()
        }
        $(this).html('')  // 隐藏 B2C 优惠码组件
        return
      }

      if (product_detail_max_discount) {
        this.startAt = product_detail_max_discount.startAt
        this.endAt = product_detail_max_discount.endAt

        this.gid = product_detail_max_discount.gid
        this.vid = product_detail_max_discount.vid
        this.code = product_detail_max_discount.code
        this.price = product_detail_max_discount.price

        this.discount = product_detail_max_discount.discount

        this.setDiscount()

        this.timerCode = setInterval(() => {
          this.isShowCode()
        }, 1000 * 5)
        this.isShowCode()
        return
      }
    }

    $(this).html('')
  }

  // 设置折扣
  setDiscount() {
    const fixedOffBlockNode = this.queryScope('.le-fixed-off-block .code-price');
    const codePriceNode = $(this).find('.code-price');

    // 计算节省金额（cents），用于 checkbox 标签和价格切换
    if (this.discount?.amount?.amount) {
      this.savingCents = Math.round(this.discount.amount.amount * 100)
      const percentage = `${Math.floor(this.discount.amount.amount / this.price * 100)}%`
      codePriceNode.html(percentage)
      fixedOffBlockNode.html(percentage)
    } else if (this.discount?.percentage) {
      // 与 Shopify 服务端对齐：先算折后价(ceil)，再反推节省额，避免 €0.01 误差
      this.salePrice = Math.ceil(this.variantPrice * (1 - this.discount.percentage))
      this.savingCents = this.variantPrice - this.salePrice
      const percentage = `${Math.floor(this.discount.percentage * 100)}%`
      codePriceNode.html(percentage)
      fixedOffBlockNode.html(percentage)
    }

    if (!this.salePrice) {
      this.salePrice = this.variantPrice - this.savingCents
    }

    // 更新 checkbox 标签中的节省金额（DE: {amount} {symbol}）
    const savingFormatted = window.ShopifyConstant.formatMoney(this.savingCents / 100)
    $(this).find('.code-save-amount').html(`${savingFormatted} ${this.currencySymbol}`)
  }

  // 绑定复制code事件 & checkbox 折扣切换
  bindEvent () {
    const _that = this

    $(this).find('.copy-btn').on('click', function () {
      const textarea = $('<textarea>').val(_that.code).appendTo('body').select()
      document.execCommand('copy')
      textarea.remove()

      $(this).text('Erfolgreich kopiert')
    })

    // checkbox：勾选后主价格切换为折后价，底部固定栏同步更新
    $(this).on('change', '.discount-toggle', function () {
      const checked = this.checked
      const symbol = _that.currencySymbol

      // 商详页主价格（product-info 内，排除 lepro-fixed-add-cart）
      const productInfo = $(_that).closest('product-info')
      const mainPriceSale = productInfo.find('.price-sale').not('lepro-fixed-add-cart .price-sale')
      const mainPriceSaving = productInfo.find('.price-saving').not('lepro-fixed-add-cart .price-saving')

      // 底部固定栏
      const fixedBar = productInfo.find('lepro-fixed-add-cart')
      const fixedSaleNode = fixedBar.find('.price-sale')
      const fixedRegularNode = fixedBar.find('.price-regular')
      const fixedSavingNode = fixedBar.find('.price-saving')

      if (checked) {
        // DE 格式：{amount} {symbol}
        const salePriceFmt = window.ShopifyConstant.formatMoney(_that.salePrice / 100) + ' ' + symbol
        const originalFmt = window.ShopifyConstant.formatMoney(_that.variantPrice / 100) + ' ' + symbol
        const savingFmt = 'Rabatt ' + window.ShopifyConstant.formatMoney(_that.savingCents / 100) + ' ' + symbol

        mainPriceSale.html(salePriceFmt)
        mainPriceSaving.html(savingFmt).show()

        fixedSaleNode.html(salePriceFmt)
        fixedRegularNode.html(originalFmt).show()
        fixedSavingNode.html(savingFmt).show()
      } else {
        const originalFmt = window.ShopifyConstant.formatMoney(_that.variantPrice / 100) + ' ' + symbol

        mainPriceSale.html(originalFmt)
        mainPriceSaving.hide()

        fixedSaleNode.html(originalFmt)
        fixedRegularNode.hide()
        fixedSavingNode.hide()
      }
      const quantityInput = productInfo.find('quantity-input')[0]
      quantityInput?.autoSetFixedPrice?.(Number(quantityInput.input?.value) || 1)
    })
  }

  /**
   * 设置折扣倒计时状态
   * return 'load' 说明是折扣时间中，但是还没有到倒计时
   * return 'end' 说明折扣还是不能时候状态
   * return endTime - currentTime 说明是折扣时间中并且可以开始倒计时, 还有多少倒计时的时间戳(需要使用这个来设置倒计时)
   */
  countDown () {
    const nowDate = new Date()

    const currentTime_us = this.formatterTime(nowDate)

    const currentTime = new Date(currentTime_us).getTime()
    const startTime = new Date(this.startAt.replace('Z', '')).getTime()
    const endTime = new Date(this.endAt.replace('Z', '')).getTime()

    const timeStamp = 24 * 60 * 60 * 1000 * this.dayNum

    if (endTime - currentTime > timeStamp) {
      return 'load'
    }

    if (currentTime > endTime || currentTime < startTime) {
      $(this).find('.le-off-code').hide();
      this.queryScope('.le-fixed-off-block').hide();
      return 'end';
    }

    return endTime - currentTime
  }

  // 开始倒计时
  beginsTime () {
    this.timer = setInterval(() => {
      const remainTime = this.countDown()
      switch (remainTime) {
        case 'end':
          this.clearTimer()
          break;
        case 'load':
          break;
        default:
          const codeTimeNode = $(this).find('.code-info .code-time')
          if (codeTimeNode.is(':hidden')) {
            codeTimeNode.css({ display: 'flex' })
          }
          this.combinationNode(remainTime)
          break;
      }
    }, 1000)
  }

  // 判断是否展示折信息
  isShowCode () {
    if (!(this.endAt && this.startAt)) return

    const currentDate = new Date(this.formatterTime(new Date())).getTime()
    const endAt = new Date(this.endAt.replace('Z', '')).getTime()
    const startAt = new Date(this.startAt.replace('Z', '')).getTime()

    if (endAt - currentDate < 0 || startAt - currentDate > 0) return

    const dataNum = this.combinationNode(endAt - currentDate)

    clearInterval(this.timerCode);
    this.timerCode = null;
    $(this).find('.le-off-code').css({ display: 'flex' });
    this.queryScope('.le-fixed-off-block').show();

    this.beginsTime()
  }

  // 倒计时的内容
  combinationNode (timestamp) {
    let seconds = Math.floor(timestamp / 1000)
    const days = Math.floor(seconds / (24 * 3600))
    seconds %= 24 * 3600
    const hours = Math.floor(seconds / 3600)
    seconds %= 3600
    const minutes = Math.floor(seconds / 60)
    seconds %= 60

    const dd = String(days).padStart(2, '0');
    const hh = String(hours).padStart(2, '0');
    const mm = String(minutes).padStart(2, '0');
    const ss = String(seconds).padStart(2, '0');

    const formatted = `<span class="block-num">${dd}</span>
    <span class="code-p">d</span>
    <span class="block-num">${hh}</span>
    <span class="code-p">h</span>
    <span class="block-num">${mm}</span>
    <span class="code-p">m</span>
    <span class="block-num">${ss}</span>
    <span class="code-p">s</span>`

    $(this).find('.count-down-block').html(formatted)

    return {
      dd,
      hh,
      mm,
      ss
    }
  }

  formatterTime (date) {
    const formatter = date.toLocaleString('en-US', {
      timeZone: 'Europe/Berlin',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    })

    return formatter.replace(/24:/, '00:')
  }

  clearTimer () {
    clearInterval(this.timer)
    this.timer = null
  }

  disconnectedCallback () {
    this.clearTimer()

    clearInterval(this.timerCode)
    this.timerCode = null
  }
}

customElements.define('lepro-off-code', LeproOffCode);
